import { HttpErrorResponse } from '@angular/common/http';

export function forcedLogoutFn(error: HttpErrorResponse): boolean {
  if (error.status === 401 && [30002, 30003].some(err => err === error.error?.errorCode)) {
    return true;
  }
  return false;
}
